import React from 'react';
import { Section } from './ui/Section';
import { CheckCircleIcon, XCircleIcon } from 'lucide-react';
export function AudienceSection() {
  return <Section id="audience" background="warm" data-id="element-53">
      <div className="grid md:grid-cols-2 gap-12 mb-20" data-id="element-54">
        <div data-id="element-55">
          <h3 className="text-2xl font-bold text-navy mb-6 flex items-center" data-id="element-56">
            <CheckCircleIcon className="h-6 w-6 text-teal mr-3" data-id="element-57" />
            Esto es para ti si:
          </h3>
          <ul className="space-y-4" data-id="element-58">
            {['Vives “acelerado/a” y ya te cansaste de aguantar', 'Tienes trabajo/negocio/familia y poco tiempo', 'Quieres algo simple que puedas hacer hoy', 'Te interesa bienestar/productividad pero odias el humo'].map((item, i) => <li key={i} className="flex items-start bg-white p-4 rounded-lg shadow-sm" data-id="element-59">
                <span className="text-teal font-bold mr-3" data-id="element-60">✓</span>
                <span className="text-gray-700" data-id="element-61">{item}</span>
              </li>)}
          </ul>
        </div>

        <div data-id="element-62">
          <h3 className="text-2xl font-bold text-navy mb-6 flex items-center" data-id="element-63">
            <XCircleIcon className="h-6 w-6 text-red-400 mr-3" data-id="element-64" />
            No es para ti si:
          </h3>
          <ul className="space-y-4" data-id="element-65">
            {['Buscas diagnóstico, terapia profunda o tratamiento médico', 'Quieres una promesa de “cero ansiedad”', 'No vas a practicar 10 minutos al día'].map((item, i) => <li key={i} className="flex items-start bg-white p-4 rounded-lg shadow-sm opacity-80" data-id="element-66">
                <span className="text-red-400 font-bold mr-3" data-id="element-67">✕</span>
                <span className="text-gray-600" data-id="element-68">{item}</span>
              </li>)}
          </ul>
        </div>
      </div>

      <div className="bg-white rounded-3xl p-8 md:p-12 shadow-lg border border-warm-gray" data-id="element-69">
        <h3 className="text-2xl md:text-3xl font-bold text-navy mb-8 text-center" data-id="element-70">
          Objeciones (las que sí importan)
        </h3>

        <div className="grid md:grid-cols-3 gap-8" data-id="element-71">
          {[{
          q: '“Ya intenté respirar y no me sirvió.”',
          a: 'Porque respiraste como tip suelto. Aquí tienes orden + duración + cierre para evitar rebote.'
        }, {
          q: '“No tengo tiempo.”',
          a: 'Perfecto. Este protocolo fue diseñado para gente que no tiene tiempo. Tu meta no es hacerlo perfecto. Es hacerlo aunque sea.'
        }, {
          q: '“Siento que lo mío es más fuerte.”',
          a: 'Por eso existe el semáforo y el protocolo de emergencia de 5 minutos. Empiezas donde estás.'
        }].map((item, i) => <div key={i} className="space-y-3" data-id="element-72">
              <p className="font-bold text-teal text-lg italic" data-id="element-73">{item.q}</p>
              <p className="text-gray-700 leading-relaxed" data-id="element-74">{item.a}</p>
            </div>)}
        </div>
      </div>
    </Section>;
}